
import { Component, Vue, Emit, Watch } from "vue-property-decorator";
import LoadingAnimation from "@/components/loading/LoadingAnimation.vue";
import store from "@/store";
const Words: Dictionary = {
  error: "所属先IDまたは所属先パスワードに誤りがあります。",
  account: "所属先ID",
  password: "所属先パスワード",
  login: "次へ",
};
@Component({
  components: {
    LoadingAnimation,
  },
})
export default class FormAlignmentLine extends Vue {
  private words = Words;
  private username = null;
  private password = null;
  private agree: boolean = false;
  private error: string | null = null;
  private meta = this.$route.meta;
  private loading: boolean = false;
  private showLoading: boolean = false;
  private loadingTimerId: number | null = null;

  private lineAccessToken = this.meta ? this.meta.lineAccessToken : null;
  private redirectPayload: { access_token: string; id_token: string } | null =
    null;

  get lang(): string {
    return store.getters["auth/lang"];
  }

  @Watch("loading")
  private onChagedLoading(newState: boolean) {
    if (this.loadingTimerId) {
      clearTimeout(this.loadingTimerId);
      this.loadingTimerId = null;
    }
    if (newState) {
      this.loadingTimerId = window.setTimeout(() => {
        this.showLoading = true;
        this.loadingTimerId = null;
      }, 3000);
    } else {
      this.showLoading = false;
    }
  }

  @Emit()
  private async onSubmit() {
    this.error = null;

    if (!this.username || !this.password) {
      console.warn("所属先IDまたは所属先パスワードに誤りがあります。");
      this.error = "所属先IDまたは所属先パスワードに誤りがあります。";
      return;
    }

    if (!this.agree) {
      console.warn("利用規約への同意をお願いします");
      this.error = "利用規約への同意をお願いします";
      return;
    }

    try {
      this.loading = true;
      store.commit("auth/updateLine", this.redirectPayload);
      const resToken = await store
        .dispatch("auth/login", {
          username: this.username,
          password: this.password,
          action: "token",
          line_id_token: this.redirectPayload
            ? this.redirectPayload.id_token
            : "",
        })
        .catch((e) => {
          if (e.status === 406) {
            throw {
              message: `ご指定の所属先IDでは、LINE機能を介した<br class='pc'>ログインをご利用いただけません。<br><br><a href="/">ログイン画面</a>に戻り、「所属先ID・パスワードでログイン」からお進みください。`,
            };
          } else {
            throw {
              message: "所属先IDまたは所属先パスワードに誤りがあります。",
            };
          }
        });
      if (resToken.redirectUrl) {
        throw {
          message: "所属先IDまたは所属先パスワードに誤りがあります。",
        };
      }

      if (!this.redirectPayload) {
        console.warn("LINEアクセストークンがありません");
        throw {
          message: "システムエラー",
        };
      }
      try {
        await store.dispatch(
          "auth/lineRegister",
          this.redirectPayload.access_token
        );
        this.$emit("updateViewState", 2);
      } catch (e) {
        console.error(e);
        if (e.status === 406) {
          throw {
            message: `ご指定の所属先IDでは、LINE機能を介した<br class='pc'>ログインをご利用いただけません。<br><br><a href="/">ログイン画面</a>に戻り、「所属先ID・パスワードでログイン」からお進みください。`,
          };
        } else {
          throw {
            message: "システムエラー",
          };
        }
      }
    } catch (e: any) {
      console.error("catch", e);
      this.error = e.message;
    } finally {
      this.loading = false;
    }
  }

  created() {
    if (store.state.temp.redirectPayload) {
      this.redirectPayload = store.state.temp.redirectPayload;
    } else {
      this.$router.push({
        name: "error",
        query: {
          status: "500",
        },
      });
    }
  }
}
